export const excludeType: Readonly<any> = {
    0: 'Schema/Owner',
    1: 'Object Type',
    2: 'Object'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/excludeType.ts